import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  p: '¿Necesito experiencia previa?',
  r: ['No. No necesitás experiencia previa para realizar el curso.', 'El programa Open Water Diver está diseñado específicamente para personas que nunca bucearon antes. Aprenderás paso a paso desde cero, acompañado por instructores profesionales que te guiarán durante todo el proceso de formación.', 'Miles de alumnos realizaron su primera experiencia bajo el agua con nosotros y obtuvieron su certificación internacional PADI.']
}, {
  p: '¿Desde qué edad puedo realizarlo?',
  r: ['A partir de los 10 años ya podés realizar el curso Open Water Diver de PADI.', 'El contenido y los ejercicios se adaptan a la edad y experiencia de cada alumno, permitiendo una formación segura, progresiva y divertida.']
}, {
  p: '¿Puedo certificarme en otro país?',
  r: ['Sí.', 'Si elegís la modalidad Referral, podés realizar toda la parte académica y las prácticas en piscina con nosotros en Buenos Aires, y completar tus inmersiones en aguas abiertas en cualquier centro PADI del mundo.', 'PADI es la certificación de buceo recreativo más reconocida internacionalmente, por lo que tu entrenamiento será válido en miles de centros de buceo alrededor del planeta.', 'Además, si lo necesitás, podemos orientarte y ayudarte a encontrar un centro PADI adecuado para completar tu certificación durante tu próximo viaje.']
}, {
  p: '¿La certificación vence?',
  r: ['No.', 'La certificación Open Water Diver de PADI no tiene fecha de vencimiento y es válida de por vida.', 'Una vez certificado, podrás bucear en centros de buceo de todo el mundo dentro de los límites de tu certificación.', 'Además, no deberás pagar membresías anuales ni renovaciones obligatorias para mantener tu condición de buceador certificado.', 'Si pasara mucho tiempo sin bucear, es recomendable realizar una actualización de habilidades (Refresh o ReActivate), pero tu certificación seguirá siendo válida.']
}, {
  p: '¿Está incluido todo el equipo de buceo?',
  r: ['Sí. Todo el equipamiento necesario para realizar el curso está incluido.', 'Tanto en la modalidad Referral como en la certificación completa Open Water Diver, te proporcionamos el equipo de buceo necesario para todas las prácticas y entrenamientos.', 'No necesitás comprar equipamiento para comenzar tu formación.']
}, {
  p: '¿Qué pasa si tengo miedo?',
  r: ['Es completamente normal.', 'La mayoría de nuestros alumnos nunca había respirado bajo el agua antes de realizar el curso.', 'Por eso la formación está diseñada para avanzar de manera progresiva, comenzando en un entorno controlado y siempre acompañado por instructores profesionales.', 'Nuestro objetivo no es que aprendas rápido, sino que te sientas cómodo, seguro y disfrutes la experiencia en cada etapa del entrenamiento.']
}, {
  p: '¿Debo pagar algo adicional?',
  r: ['No.', 'Tanto el programa Referral como la certificación completa Open Water Diver incluyen todo lo necesario para realizar el curso según lo detallado en cada opción.', 'No existen costos ocultos ni cargos sorpresa durante el proceso de formación.', 'Antes de reservar conocerás exactamente qué incluye cada programa y cuál es el valor total correspondiente.']
}, {
  p: '¿Cuánto tiempo tengo para completar mi certificación?',
  r: ['Nos adaptamos a tu disponibilidad.', 'Algunos alumnos completan toda su formación en apenas una semana, mientras que otros prefieren avanzar de manera más gradual según sus tiempos y compromisos personales.', 'La duración total dependerá de la frecuencia con la que realices las clases y de cuándo programes tus inmersiones en aguas abiertas.', 'Nuestro objetivo es que completes tu formación de manera cómoda, segura y sin presiones, adaptando el curso a tus necesidades siempre que sea posible.']
}, {
  p: '¿Dónde se realizan las aguas abiertas?',
  r: ['Las inmersiones en aguas abiertas se realizan en una cantera ubicada en la zona de Ezeiza, Buenos Aires.', 'Este entorno nos permite realizar la certificación en condiciones controladas y seguras, completando las cuatro inmersiones requeridas por PADI para obtener la certificación Open Water Diver.']
}, {
  p: '¿El transporte está incluido?',
  r: ['No.', 'El transporte hacia la cantera donde se realizan las aguas abiertas no está incluido dentro del programa estándar.', 'Sin embargo, si lo necesitás, podemos ayudarte a coordinar un servicio de traslado puerta a puerta para que puedas concentrarte únicamente en disfrutar la experiencia.', 'El costo del traslado dependerá de la ubicación de retiro y será informado previamente para que puedas decidir si deseás incluirlo.']
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 px-6 bg-brand-dark relative" data-id="element-162">
      <div className="max-w-3xl mx-auto" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-164">
          <h3 className="text-white font-heading font-bold text-3xl sm:text-4xl uppercase tracking-tight" data-id="element-165">
            Preguntas Frecuentes
          </h3>
        </motion.div>

        <div className="space-y-4" data-id="element-166">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="border border-brand-primary/20 rounded-xl overflow-hidden bg-brand-background" data-id="element-167">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-168">
                <span className="text-white font-medium pr-4" data-id="element-169">{faq.p}</span>
                <span className="text-brand-primary shrink-0" data-id="element-170">
                  {openIndex === index ? <Minus size={20} data-id="element-171" /> : <Plus size={20} data-id="element-172" />}
                </span>
              </button>

              <AnimatePresence data-id="element-173">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-174">
                    <div className="px-6 pb-6 text-white/70 leading-relaxed space-y-3" data-id="element-175">
                      {(Array.isArray(faq.r) ? faq.r : [faq.r]).map((par, i) => <p key={i} data-id="element-176">{par}</p>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}